import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule, ActionReducer, MetaReducer } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { cardCheckReducer } from './state/reducer';
import { CardCheckEffects } from './state/effects';
import { QUERIES } from './queries';
import { SERVICES } from './services';
import { eventsMap } from './google-tag.events';
import { ErrorEffects } from './state/error-effects';
import { createEventsMetaReducer } from '@awp/google-tag';

const gtmMetaReducer = createEventsMetaReducer(eventsMap);

export function gtmReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return gtmMetaReducer(reducer);
}

export const metaReducers: MetaReducer<any>[] = [gtmReducer];

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('cardCheck', cardCheckReducer, { metaReducers }),
    EffectsModule.forFeature([CardCheckEffects, ErrorEffects]),
  ],
  providers: [CardCheckEffects, ...QUERIES, ...SERVICES]
})
export class CardCheckApiModule {}
